export default {
  "home.heading.default": "entra a la llamada",
  "home.heading.loading": "Abriendo sala...",
  "home.heading.join": "¿listo para entrar?",
  "home.heading.joined": "ya estás dentro",
  "home.heading.pending": "esperando al host",
  "home.body.default": "crea una sala, pasa el link, y a fluir.",
  "home.body.loading": "un seg, preparando la sala.",
  "home.body.join": "revisa tu cámara y micro, y entra.",
  "home.body.joined": "la sala está activa. comparte el link o entra de una.",
  "home.body.joined_in_room": "en la sala — entra o comparte el link.",
  "home.body.pending": "la sala está cerrada. el host te dejará entrar.",
  "home.cta.create": "Crear sala",
  "home.cta.join": "Entrar a la sala",
  "home.cta.enter": "Entrar",
  "home.cta.creating": "Creando...",
  "home.cta.joining": "Entrando...",
  "home.cta.opening": "Abriendo...",
  "home.cta.pending": "Esperando acceso...",
  "home.copy_link": "copiar link",
  "home.copied": "¡copiado!",
  "home.leave": "salir de la sala",
  "home.back": "volver",
  "home.no_participants": "no hay nadie todavía",
  "home.join_by_code": "entrar con código",
  "home.code_placeholder": "ingresa el código",
  "home.name_placeholder": "tu nombre",
  "home.people_one": "persona",
  "home.people_other": "personas",
  "home.marketing.invite.title": "Crea una sala,\ncomparte el link.",
  "home.marketing.invite.body": "Un toque y listo. Pasa el link a tus amigos y cualquiera puede entrar — sin descargar nada, sin registrarse.",
  "home.marketing.invite.preview_url": "yano.ai/ROOM",
  "home.marketing.look.title": "Luce como\ntú quieras.",
  "home.marketing.look.body": "Filtros de color, suavizado, viñeta — o difumina tu cara por completo. Tu cámara, tu estilo.",
  "home.marketing.host.title": "Tu espacio,\ntus reglas.",
  "home.marketing.host.body": "Cierra la sala, silencia a alguien o sácalo por completo. El host tiene el control.",
  "home.marketing.host.locked": "Sala cerrada",
  "home.marketing.host.waiting_to_join": "Esperando para entrar",
  "home.marketing.host.wants_to_join": "quiere entrar",
  "home.marketing.anything.title": "Para lo que sea, literal.",
  "home.marketing.anything.body": "Sesiones de estudio, noches de juegos, standups de trabajo, ver algo juntos — o solo para pasar el rato.",
  "home.marketing.use_case.study_group": "📚 grupo de estudio",
  "home.marketing.use_case.game_night": "🎮 noche de juegos",
  "home.marketing.use_case.standup": "💼 standup",
  "home.marketing.use_case.watch_party": "🍿 watch party",
  "home.marketing.use_case.catch_up": "☕ ponernos al día",
  "home.marketing.use_case.jam_session": "🎸 jam session",
  "home.marketing.use_case.book_club": "📖 club de lectura",
  "home.marketing.use_case.coworking": "💻 co-working",
  "ended.heading": "llamada terminada",
  "ended.left": "saliste de la sala.",
  "ended.room_ended": "{title} ha terminado para ti.",
  "ended.rejoin": "volver a entrar",
  "ended.rejoining": "volviendo a entrar...",
  "ended.home": "volver al inicio",
  "call.connecting": "conectando",
  "call.waiting": "esperando a los demás",
  "call.invite_code": "código de invitación",
  "call.audio_on": "audio activado",
  "call.muted": "silenciado",
  "call.listening": "Escuchando",
  "call.audio_muted": "Audio silenciado",
  "call.speaking": "hablando",
  "call.you": "tú",
  "call.you_label": "Tú",
  "call.you_suffix": "(tú)",
  "call.chat_placeholder": "escribe un mensaje...",
  "call.guest": "invitado",
  "call.room_fallback": "sala",
  "call.focus_view": "Vista enfocada",
  "call.grid_view": "Vista de cuadrícula",
  "call.swap_main_video": "Cambiar video principal",
  "call.open_chat": "Abrir chat",
  "call.close_chat": "Cerrar chat",
  "call.leave_room": "Salir de la sala",
  "call.confirm_leave": "¿Salir?",
  "call.mic_on": "Micro encendido",
  "call.muted_label": "Silenciado",
  "call.camera_off": "Cámara apagada",
  "call.connect_failed": "Falló la conexión — revisa tu internet y dale de nuevo.",
  "call.camera_access_failed": "No pudimos acceder a tu cámara. Revisa los permisos del navegador y vuelve a intentar.",
  "call.recording_failed": "No se pudo empezar a grabar. La llamada seguirá sin grabación.",
  "call.initialize_failed": "Algo salió mal al iniciar la llamada. Refresca la página y vuelve a intentar.",
  "call.participants": "Participantes",
  "call.open_participants": "Ver participantes",
  "call.close_participants": "Cerrar participantes",
  "call.lock_room": "Cerrar sala",
  "call.unlock_room": "Abrir sala",
  "call.locked": "cerrada",
  "call.unlocked": "abierta",
  "call.kick_member": "Sacar de la sala",
  "call.mute_member": "Silenciar",
  "call.unmute_member": "Activar audio",
  "call.muted_by_host": "Silenciado por el host",
  "call.waiting_to_join": "Esperando para entrar",
  "call.approve": "Aceptar",
  "call.deny": "Rechazar",
  "call.profile_actions": "Acciones de perfil",
  "call.profile_in_room": "En la sala",
  "call.profile_role_host": "Host",
  "call.profile_role_you": "Tú",
  "call.profile_action_mute": "Silenciar su audio",
  "call.profile_action_mute_meta": "Solo para ti — no se enterarán",
  "call.profile_action_dm": "DM 1:1",
  "call.profile_action_dm_meta": "Inicia un chat privado",
  "call.profile_action_view": "Ver perfil completo",
  "call.profile_action_view_meta": "Bio, idiomas, sesiones pasadas",
  "call.profile_action_report": "Reportar",
  "call.profile_action_report_meta": "Marcar para revisión",
  "call.profile_sheet_close": "Cerrar acciones",
  "call.profile_open_actions": "Abrir acciones",
  "call.dm_title": "Mensaje directo",
  "call.dm_back": "Volver a acciones",
  "call.dm_close": "Cerrar mensaje directo",
  "call.dm_status_online": "En línea",
  "call.dm_in_room_with": "En esta sala",
  "call.dm_private_label": "Chat privado",
  "call.dm_private_meta": "Solo ustedes dos pueden ver estos mensajes",
  "call.dm_input_placeholder": "Envía un mensaje privado…",
  "call.dm_send": "Enviar",
  "call.dm_just_now": "ahora",
  "call.dm_seen_just_now": "Visto recién",
  "call.dm_typing": "{name} está escribiendo…",
  "call.dm_minimize": "Minimizar",
  "call.dm_active_indicator": "Abrir conversación",
  "call.dm_unread_messages": "{count} sin leer",
  "call.dm_toast_tap_to_open": "Toca para abrir",
  "call.dm_reopen_aria": "Reabrir conversación con {name}",
  "home.join_denied": "El host no te dejó entrar.",
  "home.error.room_not_found": "Ese código de sala no existe.",
  "home.error.profile_required": "Configura tu perfil para seguir.",
  "home.cta.set_up_profile": "Configurar perfil",
  "home.profile_trigger_new": "Toca para agregar tus datos",
  "home.profile_trigger_new_aria": "Configurar tu perfil",
  "home.profile_trigger_edit_aria": "Editar tu perfil",
  "profile.eyebrow_new": "di hola",
  "profile.eyebrow_edit": "tu perfil",
  "profile.title_new": "Hazlo tuyo.",
  "profile.title_edit": "Editar perfil",
  "profile.subtitle": "Unos detalles rápidos para que sepan con quién hablan.",
  "profile.add_photo": "Agregar foto",
  "profile.add_photo_soon": "fotos muy pronto",
  "profile.photo_empty": "toca para agregar foto",
  "profile.photo_ready": "foto lista",
  "profile.photo_save_first": "guarda tu perfil antes de subir una foto",
  "profile.photo_crop_caption": "encuadra tu foto",
  "profile.photo_auto_caption": "arrastra y haz zoom, se guarda en automático",
  "profile.photo_upload": "Subir foto",
  "profile.photo_replace": "Cambiar foto",
  "profile.photo_remove": "Quitar foto",
  "profile.photo_cancel": "Cancelar",
  "profile.photo_save": "Guardar foto",
  "profile.photo_uploading": "Subiendo foto…",
  "profile.photo_removing": "Quitando foto…",
  "profile.photo_choose_another": "Elegir otra",
  "profile.photo_drag_hint": "Arrastra la foto para acomodarla en el círculo. Se guarda en automático.",
  "profile.photo_zoom": "Zoom",
  "profile.photo_horizontal": "Recorte horizontal",
  "profile.photo_vertical": "Recorte vertical",
  "profile.name_label": "Nombre",
  "profile.name_placeholder": "¿Cómo te llamamos?",
  "profile.gender_label": "Soy",
  "profile.gender.woman": "Mujer",
  "profile.gender.man": "Hombre",
  "profile.gender.unspecified": "Prefiero no decirlo",
  "profile.bio_label": "Bio",
  "profile.bio_optional": "opcional",
  "profile.bio_placeholder": "Idiomas que hablas, lo que te gusta, lo que sea…",
  "profile.cta_new": "Vamos",
  "profile.cta_edit": "Guardar cambios",
  "profile.saving": "Guardando…",
  "profile.close": "Cerrar",
  "profile.error.save_failed": "No pudimos guardar tu perfil. Intenta de nuevo.",
  "profile.error.avatar_invalid_type": "Elige una imagen PNG, JPEG, GIF o WebP.",
  "profile.error.avatar_too_large": "Elige una imagen de menos de 5 MB.",
  "profile.error.avatar_too_small": "Elige una imagen de al menos 96x96 píxeles.",
  "profile.error.avatar_load_failed": "No pudimos leer esa imagen. Intenta con otra.",
  "profile.error.avatar_failed": "No pudimos subir tu foto. Intenta de nuevo.",
  "profile.error.avatar_remove_failed": "No pudimos quitar tu foto. Intenta de nuevo.",
  "effects.title": "Efectos",
  "effects.soft": "Enfoque suave",
  "effects.vignette": "Viñeta",
  "effects.face": "Difuminar cara",
  "effects.face_preview_only": "Difuminar cara (solo vista previa)",
  "effects.face_viewer_side": "Difuminar cara (lado del espectador)",
  "effects.face_strength": "Intensidad del difuminado",
  "effects.grade.off": "OFF",
  "effects.grade.pop": "POP",
  "effects.grade.warm": "CÁLIDO",
  "effects.grade.cool": "FRÍO",
  "effects.grade.bw": "B&N",
  "camera.off": "la cámara está apagada",
  "camera.check": "revisa tu cámara",
  "camera.retry": "reintentar cámara",
  "camera.ready": "cámara lista",
  "camera.idle.title": "Enciende tu cámara",
  "camera.idle.hint": "Le pediremos permiso a tu navegador cuando estés listo.",
  "camera.idle.button": "Encender cámara",
  "camera.status.idle": "Esperándote",
  "camera.status.off": "La cámara está apagada",
  "camera.status.loading": "Pidiendo acceso a la cámara...",
  "camera.status.denied": "Dale permiso a la cámara en el navegador y vuelve a intentar.",
  "camera.status.error": "Falló la vista previa de la cámara. Intenta de nuevo.",
  "camera.status.unsupported": "Este navegador no permite acceso a la cámara.",
  "camera.status.insecure": "El acceso a la cámara requiere HTTPS o localhost.",
  "camera.status.attach_failed": "No se pudo iniciar la vista previa de la cámara. Intenta de nuevo.",
  "camera.guest_name_placeholder": "Nombre del invitado",
  "camera.flip": "Cambiar cámara",
  "camera.save_name": "Guardar",
  "camera.edit_name": "Editar nombre",
  "mic.on": "Apagar micro",
  "mic.off": "Encender micro",
  "video.on": "Apagar cámara",
  "video.off": "Encender cámara",
  "chat.title": "chat",
  "chat.close": "Cerrar chat",
  "chat.loading": "cargando...",
  "chat.load_earlier": "cargar anteriores",
  "chat.empty": "no hay mensajes todavía",
  "chat.send_error": "No se envió el mensaje — intenta de nuevo.",
  "chat.input_placeholder": "escribe un mensaje...",
  "room.host": "Host",
  "app.room_default_title": "Crea una sala",
  "app.chat_connection_rejected": "El chat no pudo conectar — intenta refrescar la página.",
  "app.copy_failed": "No pudimos copiar el link. Intenta seleccionarlo y copiarlo a mano.",
  "app.chat_not_connected": "El chat aún no conecta. Dale un momento y vuelve a intentar.",
  "footer.terms": "Términos y Condiciones",
  "footer.copyright": "© 2026 Yano.AI"
}
